import React, { useState } from 'react';
import {
  Box,
  Typography,
  Paper,
  TextField,
  Button,
  Collapse,
} from '@mui/material';
import {
  ExpandMore as ExpandMoreIcon,
  ExpandLess as ExpandLessIcon,
} from '@mui/icons-material';

/**
 * SystemPromptSection Component
 *
 * Section for managing system prompt input.
 *
 * @param {Object} props
 * @param {Object} props.executionData - Execution data object
 * @param {Function} props.setExecutionData - Setter for execution data
 */
function SystemPromptSection({ executionData, setExecutionData }) {
  const [systemPromptExpanded, setSystemPromptExpanded] = useState(false);

  return (
    <Box sx={{ mb: 3 }}>
      <Typography variant="subtitle2" gutterBottom>
        System Prompt (Optional)
      </Typography>
      <Paper
        variant="outlined"
        sx={{
          p: 2,
          bgcolor: 'grey.50',
          fontFamily: 'monospace',
          fontSize: '0.875rem',
          whiteSpace: 'pre-wrap',
          minHeight: '80px',
          position: 'relative',
        }}
      >
        <Collapse in={systemPromptExpanded} collapsedSize={100}>
          <TextField
            fullWidth
            label="System Prompt"
            value={executionData.system_prompt || ''}
            onChange={e =>
              setExecutionData(prev => ({
                ...prev,
                system_prompt: e.target.value,
              }))
            }
            multiline
            rows={systemPromptExpanded ? 20 : 4}
            placeholder="Override the default system prompt..."
            variant="standard"
            sx={{
              '& .MuiInputBase-input': {
                overflow: 'hidden',
                resize: 'none',
                fontFamily: 'monospace',
                fontSize: '0.875rem',
              },
              '& textarea': {
                overflow: 'hidden !important',
                resize: 'none',
              },
              '& .MuiInputBase-root': {
                backgroundColor: 'transparent',
                '&:before': {
                  display: 'none',
                },
                '&:after': {
                  display: 'none',
                },
              },
              '& .MuiInputLabel-root': {
                display: 'none',
              },
            }}
          />
        </Collapse>
        {(executionData.system_prompt || '').length > 0 && (
          <Button
            size="small"
            onClick={() => setSystemPromptExpanded(!systemPromptExpanded)}
            endIcon={
              systemPromptExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />
            }
            sx={{
              mt: 1,
              textTransform: 'none',
              fontSize: '0.875rem',
              color: 'primary.main',
              minWidth: 'auto',
              px: 1,
            }}
          >
            {systemPromptExpanded ? 'Show less' : 'Show more'}
          </Button>
        )}
      </Paper>
    </Box>
  );
}

export default SystemPromptSection;
